import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=44e6e8cb&scoped=true&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationList.vue?vue&type=style&index=0&id=44e6e8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6e8cb",
  null
  
)

export default component.exports